export default __webpack_public_path__ + "static/media/close.6c9a81a4.svg";